export const DoppeActionTypeVideosListViewerLang = {
    defaultTexts: {
        title: 'Video title',
        description: 'Describe the video you want to promote',
        buttonText: 'Watch on',
    }
}